export interface RoastLabContent {
  hero: {
    title: { zh: string; en: string };
    image: string;
  };
  intro: {
    eyebrow: { zh: string; en: string };
    heading: { zh: string; en: string };
    body: { zh: string[]; en: string[] };
    image: string;
  };
  capacity: {
    heading: { zh: string; en: string };
    items: {
      label: { zh: string; en: string };
      value: { zh: string; en: string };
    }[];
  };
  process: {
    heading: { zh: string; en: string };
    steps: {
      n: string;
      title: { zh: string; en: string };
      desc: { zh: string; en: string };
    }[];
  };
  pricing: {
    heading: { zh: string; en: string };
    note: { zh: string; en: string };
    rows: {
      tier: { zh: string; en: string };
      qty: { zh: string; en: string };
      fee: { zh: string; en: string };
    }[];
  };
  cta: {
    heading: { zh: string; en: string };
    body: { zh: string; en: string };
  };
}

export const ROAST_LAB_CONTENT: RoastLabContent = {
  hero: {
    title: { zh: '烘豆實驗室', en: 'Roast Lab' },
    image: 'https://images.pexels.com/photos/4109743/pexels-photo-4109743.jpeg?auto=compress&w=1920',
  },
  intro: {
    eyebrow: { zh: 'Roast Lab', en: 'Roast Lab' },
    heading: {
      zh: '公開機資訊／本週可預約產能',
      en: 'Open machine status & weekly available capacity',
    },
    body: {
      zh: [
        '我們把烘豆機的時段、產能與費率全部公開，讓合作品牌與咖啡師能直接看到下週可預約量與試烘流程。',
        'ONGU Roast Lab 採用商用級熱風烘豆機，搭配杯測與曲線紀錄，每一批生豆都會記錄投／出豆量、含水率、發展時間與杯測風味，回饋給合作夥伴。',
      ],
      en: [
        'We openly publish our roaster timeslots, capacity and fee structure so partner brands and baristas can directly see next week’s available volume and the trial-roast process.',
        'ONGU Roast Lab uses commercial-grade hot air roasters paired with cupping notes and curve logs—every batch records charge / drop weight, moisture, development time and cupping notes for our partners.',
      ],
    },
    image: 'https://images.pexels.com/photos/4226896/pexels-photo-4226896.jpeg?auto=compress&w=1600',
  },
  capacity: {
    heading: { zh: '本週機台狀況', en: 'This week’s machine status' },
    items: [
      { label: { zh: '主烘豆機', en: 'Main roaster' }, value: { zh: '15kg / 每批次', en: '15kg per batch' } },
      { label: { zh: '小型試烘機', en: 'Sample roaster' }, value: { zh: '1kg / 每批次', en: '1kg per batch' } },
      { label: { zh: '本週可預約', en: 'Available this week' }, value: { zh: '約 240kg', en: '~240kg' } },
      { label: { zh: '下週可預約', en: 'Available next week' }, value: { zh: '約 360kg', en: '~360kg' } },
      { label: { zh: '維修保養', en: 'Maintenance' }, value: { zh: '每月最後週日', en: 'Last Sunday monthly' } },
      { label: { zh: '試烘排程', en: 'Trial-roast slots' }, value: { zh: '週二／週四 14:00–18:00', en: 'Tue / Thu 14:00–18:00' } },
    ],
  },
  process: {
    heading: { zh: '試烘與量產流程', en: 'Trial roast & production flow' },
    steps: [
      { n: '01', title: { zh: '送樣與需求溝通', en: 'Sample & briefing' }, desc: { zh: '提供 200g 以上生豆樣品與品牌定位、目標通路。', en: 'Send 200g+ green beans, brand positioning and target channel.' } },
      { n: '02', title: { zh: '試烘與杯測', en: 'Trial roast & cupping' }, desc: { zh: '依風味方向產出 2–3 條烘焙曲線，杯測後選定主曲線。', en: '2–3 roast curves are produced and chosen via cupping.' } },
      { n: '03', title: { zh: '簽訂合作', en: 'Agreement' }, desc: { zh: '確認量產規格、批次大小、報價與排程。', en: 'Lock spec, batch size, pricing and scheduling.' } },
      { n: '04', title: { zh: '量產與品管', en: 'Production & QC' }, desc: { zh: '每批次留存樣品與曲線檔，依協議交付。', en: 'Each batch keeps a curve log and reference cup.' } },
    ],
  },
  pricing: {
    heading: { zh: '加工費率（參考）', en: 'Processing fee (reference)' },
    note: {
      zh: '實際報價依生豆規格、批次量與包裝需求調整，最低起訂量 5kg。',
      en: 'Final pricing depends on spec, batch size and packaging. Minimum 5kg per order.',
    },
    rows: [
      { tier: { zh: '小批量', en: 'Small batch' }, qty: { zh: '5–20kg', en: '5–20kg' }, fee: { zh: 'NT$ 320 / kg 起', en: 'From NT$320 / kg' } },
      { tier: { zh: '常態合作', en: 'Standard partner' }, qty: { zh: '21–60kg', en: '21–60kg' }, fee: { zh: 'NT$ 280 / kg 起', en: 'From NT$280 / kg' } },
      { tier: { zh: 'OEM 月配', en: 'OEM monthly' }, qty: { zh: '61kg＋', en: '61kg+' }, fee: { zh: '另議', en: 'On request' } },
    ],
  },
  cta: {
    heading: { zh: '想預約一次試烘？', en: 'Book a trial roast' },
    body: {
      zh: '從 5kg 起接受試烘合作，請至批發合作頁填寫表單或來信 service@ongucoffee.com。',
      en: 'We accept trial-roast collaborations from 5kg. Submit the form on our wholesale page or email service@ongucoffee.com.',
    },
  },
};
